import React, {useContext, useEffect, useState} from 'react';
import { useNavigate, useParams, Link } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import BotonVolver from '../components/BotonVolver';
import resourcesServices from '../services/resourcesServices';
import { errorMessage } from '../errorHandler';
import TextControlObligado from '../components/customizedInputs/TextControlObligado';
import { PDFDocument } from 'pdf-lib';
import pdfVacio from '../assets/pdf/declaracion-pdf.pdf';

const RegistroPublicoObligado = () => {
  const tipo_doc = ["dni", "lc", "le"]
  const estado_civil = ["soltero", "casado", "viudo", "divorciado"]

  const [saving, setSaving] = useState(false);
  const [adjunto, setAdjunto] = useState(undefined);
  const [finalizado, setFinalizado] = useState(false);
  const [datosUsuario, setDatosUsuario] = useState({
    // "leyend":{"tipo":"leyend", "value": "Ingrese su email y repitalo"},
    "email":{"autocompletar":true, "tipo":"", "atributo":"email", "requerido": false},
    "confirmar_email":{"autocompletar":true, "tipo":"", "atributo":"confirmar_email", "requerido": false},
    // "documentos":{"autocompletar":false, "tipo":"file", "atributo":"documentos", "value":""},
    });

  const [camposBasicos, setCamposBasicos] = useState({
    "nombre":{"autocompletar":true, "tipo":"", "atributo":"nombre", "requerido": false},
    "apellido":{"autocompletar":true, "tipo":"", "atributo":"apellido", "requerido": false},
    "f_nacimiento":{"autocompletar":false, "label": "Fecha Nacimiento","tipo":"birthday", "atributo":"preferencias_usuario.f_nacimiento", "requerido": true},
    "tipo_doc":{"autocompletar":false,"tipo":"select", "options":tipo_doc, "atributo":"preferencias_usuario.tipo_doc", "requerido": true},
    "documento_identidad":{"autocompletar":true, "tipo":"", "atributo":"documento_identidad", "requerido": false},
    "nacionalidad":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.nacionalidad", "requerido": false},
    "telefono_particular":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.telefono_particular", "requerido": false},
    "telefono_laboral":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.telefono_laboral", "requerido": false},
    "estado_civil":{"autocompletar":false,"tipo":"select", "options":estado_civil, "atributo":"preferencias_usuario.estado_civil", "requerido": true},
    "nombre_conyuge":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.nombre_conyuge", "requerido": false},
    "apellido_conyuge":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.apellido_conyuge", "requerido": false},
    "cargo":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.cargo", "requerido": false},
    "organismo":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.organismo", "requerido": false},
    "leyend1":{"tipo":"leyend", "value": "Hacer saber que me desempeño/desempeñé en el cargo indicado precedentemente desde"},
    "f_cargo_desde":{"autocompletar":true,"tipo":"birthday", "label": "Cargo Desde", "atributo":"preferencias_usuario.f_cargo_desde", "requerido": false},
    "numero_alta_norma_legal":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.numero_alta_norma_legal", "requerido": false},
    "leyend2":{"tipo":"leyend", "value": "Si corresponde, hacer saber que me desempeño/desempeñé en el cargo indicado precedentemente hasta"},
    "f_cargo_hasta":{"autocompletar":true,"tipo":"birthday", "label": "Cargo Hasta", "atributo":"preferencias_usuario.f_cargo_hasta", "requerido": false},
    "numero_baja_norma_legal":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.numero_baja_norma_legal", "requerido": false},
  });


  const [camposDomicilioReal, setCamposDomicilioReal] = useState({
    "calle_real":{"autocompletar":true,"tipo":"", "label": "Dirección (calle y nº)", "atributo":"preferencias_usuario.calle_real"},
    "barrio_real":{"autocompletar":true, "tipo":"", "label": "Barrio", "atributo":"preferencias_usuario.barrio_real"},
    "localidad_real":{"autocompletar":true, "tipo":"", "label": "Localidad", "atributo":"preferencias_usuario.localidad_real"},
    "cp_real":{"autocompletar":true, "tipo":"", "label": "Código Postal", "atributo":"preferencias_usuario.cp_real"}
    });

  const [camposDomicilioLegal, setCamposDomicilioLegal] = useState({
    "calle_legal":{"autocompletar":true, "tipo":"", "label": "Dirección (calle y nº)", "atributo":"preferencias_usuario.calle_legal"},
    "barrio_legal":{"autocompletar":true, "tipo":"", "label": "Barrio", "atributo":"preferencias_usuario.barrio_legal"},
    "localidad_legal":{"autocompletar":true, "tipo":"", "label": "Localidad", "atributo":"preferencias_usuario.localidad_legal"},
    "cp_legal":{"autocompletar":true, "tipo":"", "label": "Código Postal", "atributo":"preferencias_usuario.cp_legal"},
  });


  const navigate = useNavigate();
  const [authInformation] = useContext(InputContext)
  const [renderHTML, setRenderHTML] = useState(false)
  const [registroPdf, setRegistroPdf] = useState({})
  const [pdfUrl, setPdfUrl] = useState(null);
  const [step, setStep] = useState(3);


  useEffect(() => {
   if( authInformation.autenticado === true && authInformation.rol === 'MesaEntrada'){
      setRenderHTML(false)
      navigate(`/`);
    } else {
      setRenderHTML(true)
    }
  }, [authInformation]);

  const generatePdf = async () => {
    const fecha = new Date();
    const hoy = fecha.getDate();
    const meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio","Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
    const dias = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"]
    const mesActual = fecha.getMonth();
    const diaActual = fecha.getDay();

    const fromBytes = await fetch(pdfVacio).then((res) => res.arrayBuffer());

    // Load the PDF with form fields
    const pdfDoc = await PDFDocument.load(fromBytes);

    const form = pdfDoc.getForm();

    const fieldFechaActual = form.getTextField('fecha_actual')

    fieldFechaActual.setText(`${dias[diaActual]}, ${String(hoy)} de ${meses[mesActual]} de ${fecha.getFullYear()}`)
    fieldFechaActual.enableReadOnly();

    for (const key in camposBasicos) {

      if(key === 'f_nacimiento') {
        const [ ano, mes, dia ] = (camposBasicos[key].value || '2024-1-1').split("-")
        const fieldNacimD = form.getTextField('nacim_d')
        const fieldNacimM = form.getTextField('nacim_m')
        const fieldNacimA = form.getTextField('nacim_a')

        fieldNacimD.setText(dia)
        fieldNacimM.setText(mes)
        fieldNacimA.setText(ano)

        fieldNacimD.enableReadOnly();
        fieldNacimM.enableReadOnly();
        fieldNacimA.enableReadOnly();

        // console.log('nacim_d', form.getTextField('nacim_d').setText(dia));
      } else if(key === 'cargo') {
        const fieldCargo1 = form.getTextField('cargo1')
        fieldCargo1.setText( '' )

        const fieldCargo2 = form.getTextField('cargo2')
        fieldCargo2.setText(camposBasicos[key].value || '')

        fieldCargo1.enableReadOnly();
        fieldCargo2.enableReadOnly();


      } else if(key === 'documento_identidad') {
        const fieldDocumento = form.getTextField('documento')
        fieldDocumento.setText( camposBasicos[key].value || '' )
        fieldDocumento.enableReadOnly();

      } else if(key === 'f_cargo_desde') {
        const fieldFecha = form.getTextField('cargo_desde')
        fieldFecha.setText( camposBasicos[key].value || '' )
        fieldFecha.enableReadOnly();

      } else if(key === 'f_cargo_hasta') {
        const fieldFecha = form.getTextField('cargo_hasta')
        fieldFecha.setText( camposBasicos[key].value || '' )
        fieldFecha.enableReadOnly();

      } else {
        if(camposBasicos[key].tipo !== 'leyend'){
          const textField = form.getTextField(key)
          // console.log(camposBasicos[key], camposBasicos[key].value, textField )
          textField.setText( camposBasicos[key].value || '' );
          textField.enableReadOnly();
        }
      }
    }

    for (const key in datosUsuario) {
      if(key === 'email') {
        const textField = form.getTextField(key)
        textField.setText( datosUsuario[key].value || '' );
        textField.enableReadOnly();
      }
    }

    for (const key in camposDomicilioReal) {
      if(key === 'cp_real') {
        const fieldCpReal = form.getTextField('codigo_postal_real')
        fieldCpReal.setText( camposDomicilioReal[key].value || '' )
        fieldCpReal.enableReadOnly();
      } else {
        const fieldDomReal = form.getTextField(key)
        fieldDomReal.setText( camposDomicilioReal[key].value || '' )
        fieldDomReal.enableReadOnly();
      }
    }

    for (const key in camposDomicilioLegal) {
      if(key === 'cp_legal') {
        const fieldCpLegal = form.getTextField('codigo_postal_legal')
        fieldCpLegal.setText( camposDomicilioLegal[key].value || '' )
        fieldCpLegal.enableReadOnly();
      } else {
        const fieldDomLegal = form.getTextField(key)
        fieldDomLegal.setText( camposDomicilioLegal[key].value || '' )
        fieldDomLegal.enableReadOnly();
      }
    }

    const pdfBytes = await pdfDoc.save();

    // Convertir el array de bytes a un Blob
    const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });

    // Crear un objeto URL para mostrar el PDF
    const pdfUrl = URL.createObjectURL(pdfBlob);

    setPdfUrl(pdfUrl);
  }


  const validarCampos = async () => {
    try {
      setSaving(true)

      const newObject = {...camposBasicos, ...camposDomicilioReal, ...camposDomicilioLegal, ...datosUsuario}

      const attributeName = 'usuario'
      const formData =  new FormData();
      for(const [_, value] of Object.entries(newObject)){
        if(value.atributo){
          if (value.atributo.includes('.')) {
            const [parentKey, childKey] = value.atributo.split('.');

            formData.append(`${attributeName}[${parentKey}_attributes][${childKey}]`, value.value || '')

          } else {
            formData.append(`${attributeName}[${value.atributo}]`, value.value || '')
          }
        }
      }

      formData.append(`skip_some_user_attributes`, true)

      await resourcesServices.crearResource('usuarios/validarContenido', formData);

      setSaving(false)
      alert("Datos Validos")
      await generatePdf()

    } catch (error) {
      setSaving(false)
      errorMessage(error)
    }
  };

  const guardarObligado = async () => {
    try {
      setSaving(true)

      await generatePdf()

      const newObject = {...camposBasicos, ...camposDomicilioReal, ...camposDomicilioLegal, ...datosUsuario}

      const attributeName = 'registro_pdf'
      const formData =  new FormData();
      for(const [_, value] of Object.entries(newObject)){
        if(value.atributo){
          if (value.atributo.includes('.')) {
            const [parentKey, childKey] = value.atributo.split('.');

            formData.append(`${attributeName}[${parentKey}_attributes][${childKey}]`, value.value || '')

          } else {
            formData.append(`${attributeName}[${value.atributo}]`, value.value || '')
          }
        }
      }

      formData.append(`${attributeName}[adjunto]`, adjunto)

      await resourcesServices.crearResource('registro_pdfs', formData);

      setSaving(false)
      setFinalizado(true)
      alert("Información actualizada")

    } catch (error) {
      setSaving(false)
      console.log(error)
      errorMessage(error)
    }
  };

  const mismoDomicilioReal = () => {

    const calle_legal = camposDomicilioLegal.calle_legal
    calle_legal["value"] = camposDomicilioReal.calle_real.value

    const barrio_legal = camposDomicilioLegal.barrio_legal
    barrio_legal["value"] = camposDomicilioReal.barrio_real.value

    const localidad_legal = camposDomicilioLegal.localidad_legal
    localidad_legal["value"] = camposDomicilioReal.localidad_real.value

    const cp_legal = camposDomicilioLegal.cp_legal
    cp_legal["value"] = camposDomicilioReal.cp_real.value

    setCamposDomicilioLegal({...camposDomicilioLegal,
      ['calle_legal']: calle_legal,
      ['barrio_legal']: barrio_legal,
      ['localidad_legal']: localidad_legal,
      ['cp_legal']: cp_legal,
    })
  }

  const verificarEmail = () => {
    return datosUsuario.email.value && datosUsuario.email.value.length>0 && datosUsuario.email.value === datosUsuario.confirmar_email.value
  }

  const handleFormSubmit = (e) => {
    e.preventDefault()
    // guardarObligado()
    if(verificarEmail()){
      validarCampos()
    } else {
      alert("Ingrese su email y su verifique que la confirmación sea el mismo email.")
    }
  }

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setAdjunto(files[0])
  };

  const handleInput = (e, section) => {
    let { name, value, files, type } = e.target;


    if (name.includes('.')) {
      const [parentKey, childKey] = name.split('.');
      name = childKey
    }


    if(section === 'camposBasicos'){
      const updatedCamposBasicos = { ...camposBasicos };
      if (Object.hasOwnProperty.call(updatedCamposBasicos, name)) {
        updatedCamposBasicos[name].value = value;
      }
      setCamposBasicos(updatedCamposBasicos);
    } else if(section === 'camposDomicilioLegal'){
      const updatedCamposDomicilioLegal = { ...camposDomicilioLegal };
      if (Object.hasOwnProperty.call(updatedCamposDomicilioLegal, name)) {
        updatedCamposDomicilioLegal[name].value = value;
      }
      setCamposDomicilioLegal(updatedCamposDomicilioLegal);
    } else if(section === 'camposDomicilioReal'){
      const updatedCamposDomicilioReal = { ...camposDomicilioReal };
      if (Object.hasOwnProperty.call(updatedCamposDomicilioReal, name)) {
        updatedCamposDomicilioReal[name].value = value;
      }
      setCamposDomicilioReal(updatedCamposDomicilioReal);
    } else if(section === 'datosUsuario'){
      const updatedDatosUsuario = { ...datosUsuario };
      if (Object.hasOwnProperty.call(updatedDatosUsuario, name)) {
        if(type==='file'){
          updatedDatosUsuario[name] = files;
        } else {
          updatedDatosUsuario[name].value = value;
        }
      }
      setDatosUsuario(updatedDatosUsuario);
    }
  }

  return (
    <div>
      {renderHTML && (
        <>
        <h1>Registro de Obligado <BotonVolver /></h1>
        {
          camposBasicos && camposDomicilioReal && camposDomicilioLegal && (
          <form id="carouselExample" className='carousel slide' onSubmit={handleFormSubmit}>
            <div className='carousel-inner p-3'>
              <div className='carousel-item active'>
                <h5>Paso 1/2</h5>
                <div className="row mt-3">
                  <div className="col-6">
                    <div className="card mb-5">
                      <div className="card-body">
                        <h5 className="card-title">Información personal</h5>
                        {
                          Object.entries(camposBasicos).map(([key, value]) => (
                            <div key={key}>
                              <TextControlObligado
                                autocompletar={value.autocompletar}
                                required={value.requerido}
                                label={value.label}
                                value={value.value}
                                options={value.options || []}
                                type={value.tipo}
                                attributeModelName={value.atributo || key}
                                handleInput={(e) => handleInput(e, 'camposBasicos')}
                              />
                            </div>
                          ))
                        }
                      </div>
                    </div>

                    <div className="card mb-5">
                      <div className="card-body">
                        <h5 className="card-title">Datos de Usuario</h5>
                        {
                          Object.entries(datosUsuario).map(([key, value]) => (
                            <div key={key}>
                              <TextControlObligado
                                autocompletar={value.autocompletar}
                                label={value.label}
                                value={value.value}
                                options={value.options || []}
                                type={value.tipo}
                                attributeModelName={value.atributo || key}
                                handleInput={(e) => handleInput(e, 'datosUsuario')}
                              />
                            </div>
                          ))
                        }
                        {/* <input
                          placeholder="Adjunte los documentos"
                          className="form-control"
                          onChange={handleFileChange}
                          name="documentos"
                          type="file"
                          id="documentos"
                          multiple
                        /> */}

                      </div>
                    </div>

                  </div>
                  <div className="col-6">
                    <div className="card mb-5">
                      <div className="card-body">
                        <h5 className="card-title">Domicilio Real</h5>
                        {
                          Object.entries(camposDomicilioReal).map(([key, value]) => (
                            <div key={key}>
                              <TextControlObligado
                                autocompletar={value.autocompletar}
                                label={value.label}
                                value={value.value}
                                options={value.options || []}
                                type={value.tipo}
                                attributeModelName={value.atributo || key}
                                handleInput={(e) => handleInput(e, 'camposDomicilioReal')}
                                />
                            </div>
                          ))
                        }
                      </div>
                    </div>

                    <div className="d-grid gap-2 mb-3">
                      <button className="btn btn-info" onClick={() => mismoDomicilioReal()} type="button">Mismo Domicilio Real</button>
                    </div>


                    <div className="card mb-5">
                      <div className="card-body">
                        <h5 className="card-title">Domicilio Legal</h5>
                        {
                          Object.entries(camposDomicilioLegal).map(([key, value]) => (
                            <div key={key}>
                              <TextControlObligado
                                autocompletar={value.autocompletar}
                                label={value.label}
                                value={value.value}
                                options={value.options || []}
                                type={value.tipo}
                                attributeModelName={value.atributo || key}
                                handleInput={(e) => handleInput(e, 'camposDomicilioLegal')}
                              />
                            </div>
                          ))
                        }
                      </div>
                    </div>

                  </div>
                </div>
                {
                  registroPdf.usuario && registroPdf.usuario.id && (
                    <>
                    <div className='alert alert-warning' role='alert'>
                      <b>Existe un usuario con este documento.</b><br />
                      Al guardar se van a actualizar los datos del usuario existente con los nuevos datos. <br />
                      La información del cargo anterior se va a archivar para ser reempazado por este nuevo cargo.
                    </div>
                    <div className='alert alert-warning' role='alert'>
                      <b>Nombre completo:</b> {registroPdf.usuario.nombre + ' ' + registroPdf.usuario.apellido}<br />
                      <b>Documento:</b> {registroPdf.usuario.documento_identidad}<br />
                      <b>Email:</b> {registroPdf.usuario.email}<br />
                      <b>Usuario:</b> {registroPdf.usuario.usuario}<br />
                    </div>
                    </>
                  )
                }
                <button disabled={saving} className="btn btn-danger mt-3 me-3" type="submit">
                  {saving && (<span className="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>)}
                  <span role="status">Verificar</span>
                </button>
                { pdfUrl && (
                  <button disabled={step===1} className="btn btn-primary mt-3" data-bs-target="#carouselExample" data-bs-slide="next" type="button">Siguiente Paso</button>
                )
                }

              </div>
              <div className='carousel-item'>
                {finalizado ? (
                  <>
                  <h5>Finalizado</h5>
                  <div className='fs-5'>Le hemos enviado un correo a <b>{datosUsuario["email"]["value"]}</b></div>
                  </>
                ) : (
                  <>
                    <h5>Paso 2/2</h5>
                    { pdfUrl && (
                      <>
                      Descargue el documento, fírmelo y adjúntelo firmado <br />
                      <Link to={pdfUrl} className="btn btn-primary mt-3" target='_blank'>Descargar Documento</Link>
                      <div className="mt-3 mb-3">
                        Una vez firmado, adjúntelo aquí
                        <input
                          placeholder="Adjunte el documento interactivo"
                          className="form-control"
                          onChange={handleFileChange}
                          accept='.pdf'
                          name="adjunto"
                          type="file"
                          id="adjunto" />
                      </div>
                      </>
                      )
                    }
                    <hr className='mt-3 mb-3' />
                    <button className="btn btn-danger mt-3 me-3" data-bs-target="#carouselExample" data-bs-slide="prev" type="button">Volver</button>
                    {
                      (true || (datosUsuario.adjunto && Object.keys(datosUsuario.adjunto).length !== 0)) && (
                        <button onClick={guardarObligado} disabled={saving} className="btn btn-primary mt-3" type="button">
                          {saving && (<span className="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>)}
                          <span role="status">Finalizar</span>
                        </button>
                      )
                    }
                    </>
                  )}
              </div>

            </div>
            {/* <pre>{JSON.stringify(datosUsuario, null, 2)}</pre> */}
          </form>
          )
        }
        </>
      )}
    </div>
  );
};

export default RegistroPublicoObligado;